<template>
  <!-- 瓜分奖励模块 -->
  <div class="divide-award-container" :style="{
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px'}">
    <div class="award-num" :style="{
      'background': `url(${cc.title_bg}) no-repeat center / 100% 100%`,
      'color': gc.text_color,
      'visibility': cd.hb_num ? '' : 'hidden'
      }">
      <div>{{cd.state == 2 || cd.state == 3 ? '恭喜你' : '预计可'}}分得</div>
      <div class="num">{{cd.hb_num}}</div>
      <div>H币</div>
    </div>
    <div class="header-desc" :style="{'color': hexToRgba(cc.tip_text_color || gc.main_color, .8)}">
      <template v-if="cd.state != 2">
        <span>已有</span>
        <span class="num" :style="{'color': gc.text_color, 'background-color': gc.main_color}">{{cd.total_get}}</span>
        <span>位盒友完成，</span>
        <span class="num" :style="{'color': gc.text_color, 'background-color': gc.main_color}">{{cd.open_time}}</span>
        <span>开奖</span>
      </template>
      <template v-else>
        <span>{{cd.total_get}}位盒友参与瓜分，{{cd.open_time}}已开奖</span>
      </template>
    </div>
    <div class="take-btn" @click="getAward" :style="{'background': `url(${cc.btn_bg || gc.btn_bg}) no-repeat center / 100% 100%`,'color': cd.state != 1 ? hexToRgba(gc.text_color, .5) : gc.text_color}">{{btn_desc}}</div>
    <Modal ref="success-modal" :width="299" :gc="gc" :cc="cc" title="恭喜获得">
      <div class="success-modal-wrapper modal-content">
        <div class="modal-item">
          <div class="image-box">
            <!-- <img :src="award.img_url" alt=""> -->
            <HBSvg :bg="gc.main_color"></HBSvg>
          </div>
          <p class="prize-name" :style="{'color': gc.main_color}">{{award.name}}</p>
        </div>
        <p class="distribute-desc" :style="{'color':  hexToRgba(gc.main_color, .8)}">{{award.notify_content}}</p>
        <div class="btn-done" @click="closeSuccessModal" :style="{'background': cc.modal_confirm_btn_big || gc.modal_confirm_btn_big ? `url(${cc.modal_confirm_btn_big || gc.modal_confirm_btn_big}) no-repeat center/contain` : '#0B8AFF', 'color': gc.text_color,'margin-top': '10px'}">确认</div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { ComponentCommonMixin } from '../mixin'
import { getDivideAward } from '_api/activity-common-template'
import HBSvg from '../images/hb'
export default {
  name: 'divide-award',
  components: { HBSvg },
  mixins: [ ComponentCommonMixin ],
  computed: {
    btn_desc () {
      switch (this.cd.state) {
        case -1:
          return `未完成（任务进度${this.cd.task_num}/${this.cd.total_task}）`
        case 0:
          return '已完成，坐等开奖'
        case 1:
          return '吉时到，点击领奖'
        case 2:
          return '已开奖'
        case 3:
          return '活动已结束'
      }
    }
  },
  data () {
    return {
      award: {
        name: '',
        notify_content: '奖品将放入游戏库-黑盒商城-我的钱包'
      }
    }
  },
  methods: {
    getAward () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      if (this.cd.state == 1) {
        // 领取
        getDivideAward({
          heybox_id: this.querys.heybox_id,
          act_id: this.act_id || this.querys.act_id
        }).then(res => {
          if (res.data.status === 'ok') {
            this.award.name = `H币*${res.data.result.hb_num}`
            this.showSuccessModal()
            setTimeout(() => {
              this.$parent.reload()
            }, 100)
          }
        })
        
      }
    },
    showSuccessModal () {
      this.$refs['success-modal'].showModal()
    },
    closeSuccessModal () {
      this.$refs['success-modal'].hideModal()
    },
  }
}
</script>

<style lang="less">
.divide-award-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 32px 14px 0;
  .award-num {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 10px;
    z-index: 1;
    width: 199px;
    height: 27px;
    div {
      font-size: 13px;
      line-height: 18px;
      text-align: center;
      position: relative;
      top: 1px;
      white-space: nowrap;
      &.num {
        font-family: ALIBABA Font;
        font-size: 20px;
        line-height: 24px;
        margin: 0 4px;
        top: -2px;
      }
    }
  }
  .header-desc {
    margin: 0 auto 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    span {
      font-size: 13px;
      line-height: 18px;
      z-index: 2;
    }
    .num {
      margin: 0 3px;
      padding: 0 2px;
      font-weight: 600;
      border-radius: 2px;
      height: 16px;
      line-height: 18px;
    }
  }
  .take-btn {
    font-weight: 500;
    font-size: 16px;
    line-height: 44px;
    height: 44px;
    text-align: center;
  }
  .success-modal-wrapper {
    .modal-item {
      .image-box {
        position: relative;
        overflow: hidden;
        margin: 14px auto;
        text-align: center;
      }
      .prize-name {
        font-size: 13px;
        line-height: 16px;
        max-width: 100%;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>